import { Directive, ElementRef, Input, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[smartCampainSmsRequestActiveStatus]',
  standalone: true
})
export class SmartCampainSmsRequestStatusDirective implements OnInit {


  @Input('smartCampainSmsRequestActiveStatus') status:boolean;
  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }


  getCssClassList(): string {

    let classList = "mdi tw-font-bold mdi-20px ";

    if(this.status){
        classList+='mdi-play text-success'
    }else{
        classList+='mdi-pause text-warning'
    }

    return classList;
  }
}
